var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageTitle',{attrs:{"title":"Hacker News: New"}}),_c('PostList',{attrs:{"source":"https://hacker-news.firebaseio.com/v0/newstories.json"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }